export default {

	init() {
		$('.header-ribbon-text .close-icon').on('click', function(e) {
			$(this).closest('.header-ribbon-text').addClass('dismissed');

			//Set Cookie
			const d = new Date();
			d.setTime(d.getTime() + (24*60*60*1000));
			let expires = "expires="+ d.toUTCString();
			document.cookie = 'ribbon_dismissed=true;' + expires + ";path=/";
			
			Ribbon.adjustRibbonOffset();
		});

		document.addEventListener("DOMContentLoaded", this.adjustRibbonOffset);
		$(window).on('resize', this.adjustRibbonOffset);
	},

	adjustRibbonOffset() {
		console.log('offset adjustment');

		let offset = 0;
		if($('#header-ribbon-text:not(.dismissed)').length) {
			offset = Math.floor($('#header-ribbon-text').outerHeight());
		}

		const styleRules = ':root{--mercer-ribbon-offset: ' + offset + 'px;} body{margin-top: var(--mercer-ribbon-offset);}';

		if($('style#ribbon-offset').length) {
			$('style#ribbon-offset').html(styleRules);
		} else {
			$('body').prepend('<style id="ribbon-offset">' + styleRules + '</style>');
		}
	}

};
